import { render, staticRenderFns } from "./fundos-investimento.vue?vue&type=template&id=05ba3e2b&scoped=true&"
import script from "./fundos-investimento.vue?vue&type=script&lang=js&"
export * from "./fundos-investimento.vue?vue&type=script&lang=js&"
import style0 from "./fundos-investimento.vue?vue&type=style&index=0&id=05ba3e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba3e2b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ba3e2b')) {
      api.createRecord('05ba3e2b', component.options)
    } else {
      api.reload('05ba3e2b', component.options)
    }
    module.hot.accept("./fundos-investimento.vue?vue&type=template&id=05ba3e2b&scoped=true&", function () {
      api.rerender('05ba3e2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/FundosInvestimento/fundos-investimento.vue"
export default component.exports